export default __webpack_public_path__ + "static/equipe-2cb0097000cf0547c0d4fa30cd28bde8.webp";